import Tabs from './Tabs';
import TabPane from './sugar/TabPane';
export { TabPane };
export default Tabs;